import React from "react";

// Official House of Master Brushes Fine Art crest (transparent PNG, hosted locally)
export const LOGO_URL = "/logo-master-brushes.png";

export function Logo({ size = 96, className = "" }) {
  return (
    <img
      src={LOGO_URL}
      alt="House of Master Brushes Fine Art"
      width={size}
      height={size}
      style={{ width: size, height: size, objectFit: "contain" }}
      className={className}
      data-testid="brand-logo"
      draggable={false}
    />
  );
}

// Small horizontal ornament divider used between sections
export function Ornament({ color = "#D4AF37", className = "" }) {
  return (
    <div className={`ornate-divider ${className}`}>
      <svg width="26" height="14" viewBox="0 0 26 14" fill="none">
        <path
          d="M1 7 Q6 1 13 7 Q20 13 25 7"
          stroke={color}
          strokeWidth="1"
          fill="none"
        />
        <circle cx="13" cy="7" r="2.2" fill={color} />
      </svg>
    </div>
  );
}
